import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {$} from '@/facade'

export class ExchangeSupportedTokens implements IResource {
  id: number = 0
  title: string | null = null

  constructor(id: number, title: string) {
    this.id = id
    this.title = $.translate(title)
  }

  get $id() {
    return this.id
  }

  set $id(val) {
    this.id = val
  }

  get $tag() {
    return String(this.title)
  }
}
